import { styled, Box } from '@mui/material';

export const DashboardVariantV2GiverInfoCurrentCarrierCompanyContainer = styled(
  Box,
)(({ theme }) => ({
  padding: theme.spacing(1.5, 3),
  borderRadius: 12,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#F0F2F7',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: 270,
  textAlign: 'center',
}));
